import {ReactNode} from 'react';

import {Table, TableHead, TableHeader, TableRow} from 'components/TableComponent';
import {ITableHeaderCell} from 'typescript/models/TableHeaderCell';

interface IProps {
  tableHeaderCells: ITableHeaderCell[];
  tableHeader?: {className: string; testId?: string};
  tableBody: ReactNode;
  tableRow?: {className: string};
  table?: {className: string; testId?: string};
}

export const TableFactory = ({tableHeaderCells, tableRow, table, tableHeader, tableBody}: IProps) => {
  return (
    <Table className={table?.className || ''} data-testid={table?.testId || ''}>
      <TableHead className={tableHeader?.className || ''} data-testid={tableHeader?.testId || ''}>
        <TableRow className={tableRow?.className || ''}>
          {tableHeaderCells.map((tableHeaderCell) => {
            return (
              <TableHeader
                colSpan={tableHeaderCell.colSpan || 1}
                key={tableHeaderCell.name}
                className={tableHeaderCell.cellClass || ''}
                data-testid={tableHeaderCell.testId || ''}
              >
                <span>{tableHeaderCell.name}</span>
                {tableHeaderCell.content && tableHeaderCell.content}
                {tableHeaderCell.sort}
                {tableHeaderCell.filter}
              </TableHeader>
            );
          })}
        </TableRow>
      </TableHead>
      {tableBody}
    </Table>
  );
};
